<template>
    <div class="Invoice">
        <!-- 发票选择列表 -->
        <div
                class="InvoiceChooseList flex"
                v-if="choosestate"
                @click="CloseChooseList"
        >
            <div class="ListContent">
                <ul>
                    <li
                            v-for="(item, index) in invoicechoosedata"
                            :key="index"
                            @click="ChooseThis(item, index, $event)"
                            class="flexa"
                            :class="{ Active: index == chooseflag }"
                    >
                        <i class="flex">{{ index + 1 }}</i>
                        <div class="TextWrap">
                            <p>{{ item.发票抬头 }}</p>
                            <p>{{ item.税号 }}</p>
                        </div>
                        <div class="hidden" @click="OpenChangeInvoice(item.序号,$event)">
                            <img
                                    style="width: 0.12rem;margin-left: 0.02rem"
                                    src="../../assets/Home/edit.png"
                            />
                        </div>
                    </li>
                </ul>
                <div class="flex ChooseButton">
                    <div class="flex" @click="CloseChooseList">取消</div>
                    <div class="flex" @click="SubmitThis($event)">确定</div>
                </div>
            </div>
        </div>
        <!-- 开票申请 -->
        <div class="AddInvoice flex" v-if="SubmitInvoiceState">
            <div class="AddWrap">
                <header class="flexa">
                    <i @click="CloseSubmitInvoice"><img src="../../assets/returns.png"/></i>
                    <p>{{ invoicedetaildata.开票状态 }}</p>
                </header>
                <div class="AddInvoiceContent" style="height: calc(100% - 0.55rem)">
                    <div class="NumberWrap flexbetween">
                        <p>{{ invoicedetaildata.订单日期 }}</p>
                        <p>订单号 {{ invoicedetaildata.订单编号 }}</p>
                    </div>
                    <div class="Productpic">
                        <i><img :src="invoicedetaildata.LOGO图片"/></i>
                        <p>{{ invoicedetaildata.产品名称 }}</p>
                    </div>
                    <div class="Type flexa">
                        <div
                                class="Camponey"
                                @click="ChangeFrom(true)"
                                :class="{ Active: types }"
                        >
                            公司开票
                        </div>
                        <div
                                class="Person"
                                @click="ChangeFrom(false)"
                                :class="{ Active: !types }"
                        >
                            个人开票
                        </div>
                    </div>
                    <div class="flexbetween Choose" v-if="types">
                        <div class="ChooseType">
                            <div
                                    class="flex"
                                    @click="ChangeType(true)"
                                    :class="{ Active: state }"
                            >
                                普
                            </div>
                            <div
                                    class="flex"
                                    @click="ChangeType(false)"
                                    :class="{ Active: !state }"
                            >
                                增
                            </div>
                        </div>
                        <div
                                class="InvoiceInfo flexa"
                                v-if="!submitinvoice.发票抬头"
                                @click="OpenInvoiveList"
                        >
                            <img src="../../assets/add.png" />
                            <span>选择发票</span>
                        </div>
                        <div
                                class="InvoiceInfo flexa"
                                style="position: relative"
                                v-else
                                @click="OpenInvoiveList"
                        >
                            <img src="../../assets/camp.png" />
                            <p
                                    style="position: absolute;right: 0.1rem;top: 0.08rem;font-size: 0.051rem;color: #fff;width: 1rem;text-align: right"
                            >
                                {{ submitinvoice.发票抬头 }}
                            </p>
                            <p
                                    style="position: absolute;right: 0.1rem;bottom: 0.05rem;font-size: 0.051rem;color: #fff"
                            >
                                {{ submitinvoice.税号 }}
                            </p>
                        </div>
                    </div>
                    <div class="InputWrap">
                        <ul>
                            <li class="flexbetween" v-if="!types">
                               <span class="flex">发票抬头</span
                               ><input v-model="head" placeholder="发票抬头" />
                                               </li>
                                               <li class="flexbetween">
                               <span class="flex">联系人</span
                               ><input v-model="user" placeholder="联系人" />
                                               </li>
                                               <li class="flexbetween">
                               <span class="flex">手机号码</span
                               ><input v-model="phone" placeholder="手机号码" />
                                               </li>
                                               <li class="flexbetween">
                               <span class="flex">联系地址</span
                               ><input v-model="address" placeholder="联系地址" />
                                               </li>
                                               <li class="flexbetween">
                               <span class="flex">开票项目</span
                               ><span>{{ invoicedetaildata.发票内容 }}</span>
                                               </li>
                                               <li class="flexbetween">
                               <span class="flex">发票金额</span
                               ><span>￥ {{ invoicedetaildata.开票金额 }}</span>
                                               </li>
                        </ul>
                    </div>
                </div>
                <!-- 底部汇总 -->
                <footer>
                    <div class="ButtonWrap clearfix">
                        <div class="flex Yes" @click="SubmitInvoicedata"><span>开票</span></div>
                    </div>
                </footer>
            </div>
        </div>
        <!-- 已开票查询 -->
        <!-- 维护发票 -->
        <div class="AddInvoice EditIncoive flex" v-if="EditInvoiceState">
            <div class="AddWrap">
                <header class="flexa">
                    <i @click="CloseChangeInvoice"><img src="../../assets/returns.png"/></i>
                    <p>修改发票</p>
                </header>
                <div class="AddInvoiceType clearfix">
                    <div class="flex" @click="ChangeType(false)" :class="{ Active: !typestate }">
                        <span>普</span>
                    </div>
                    <div class="flex" @click="ChangeType(true)" :class="{ Active: typestate }">
                        <span>增</span>
                    </div>
                </div>
                <div class="AddInvoiceContent">
                    <div class="InputWrap">
                        <ul>
                            <!--用户ID,发票类型,发票类型名称,发票抬头,税号,注册地址,注册电话,开户银行,银行账号,序号,作废标识-->
                            <li class="flexbetween">
            <span class="flex">发票抬头</span
            ><input
                                    v-model="submit.head"
                                    placeholder="请输入发票抬头"
                            />
                            </li>
                            <li class="flexbetween">
            <span class="flex">纳税人识别号</span
            ><input
                                    v-model="submit.id"
                                    placeholder="请输入纳税人识别号"
                            />
                            </li>
                            <li class="flexbetween tip" v-if="!typestate">
                                <span class="flex">以下内容为选填项</span>
                            </li>
                            <div>
                                <li class="flexbetween">
              <span class="flex">注册地址</span
              ><input
                                        v-model="submit.address"
                                        placeholder="请输入注册地址"
                                />
                                </li>
                                <li class="flexbetween">
              <span class="flex">注册电话</span
              ><input
                                        v-model="submit.phone"
                                        placeholder="请输入注册电话"
                                />
                                </li>
                                <li class="flexbetween">
              <span class="flex">开户银行</span
              ><input
                                        v-model="submit.bank"
                                        placeholder="请输入开户银行"
                                />
                                </li>
                                <li class="flexbetween">
              <span class="flex">银行账号</span
              ><input
                                        v-model="submit.bankid"
                                        placeholder="请输入银行账号"
                                />
                                </li>
                            </div>
                        </ul>
                    </div>
                </div>
                <!-- 底部汇总 -->
                <footer>
                    <div class="ButtonWrap clearfix">
                        <div class="flex Yes" @click="SubmitData(3,flagid)"><span>保存</span></div>
                        <div class="flex No" @click="SubmitData(0,flagid)"><span>删除</span></div>
                    </div>
                </footer>
            </div>
        </div>
        <!-- 新增发票 -->
        <div class="AddInvoice flex" v-if="AddInvoiceState">
            <div class="AddWrap">
                <header class="flexa">
                    <i @click="CloseAddInvoice"><img src="../../assets/returns.png"/></i>
                    <p>新增发票</p>
                </header>
                <div class="AddInvoiceType clearfix">
                    <div class="flex" :class="{ Active: !typestates }" @click="ChangeType(false)">
                        <span>普</span>
                    </div>
                    <div class="flex" :class="{ Active: typestates }" @click="ChangeType(true)">
                        <span>增</span>
                    </div>
                </div>
                <div class="AddInvoiceContent">
                    <div class="InputWrap">
                        <ul>
                            <!--用户ID,发票类型,发票类型名称,发票抬头,税号,注册地址,注册电话,开户银行,银行账号,序号,作废标识-->
                            <li class="flexbetween">
            <span class="flex">发票抬头</span
            ><input
                                    id="companyName"
                                    v-model="submit.head"
                                    placeholder="请输入发票抬头"
                            />
                            </li>
                            <li class="flexbetween">
            <span class="flex">纳税人识别号</span
            ><input
                                    id="ratepayerId"
                                    v-model="submit.id"
                                    placeholder="请输入纳税人识别号"
                            />
                            </li>
                            <li class="flexbetween tip" v-if="!typestates">
                                <span class="flex">以下内容为选填项</span>
                            </li>
                            <div>
                                <li class="flexbetween">
              <span class="flex">注册地址</span
              ><input
                                        id="companyAddress"
                                        v-model="submit.address"
                                        placeholder="请输入注册地址"
                                />
                                </li>
                                <li class="flexbetween">
              <span class="flex">注册电话</span
              ><input
                                        id="mobile"
                                        v-model="submit.phone"
                                        placeholder="请输入注册电话"
                                />
                                </li>
                                <li class="flexbetween">
              <span class="flex">开户银行</span
              ><input
                                        id="bank"
                                        v-model="submit.bank"
                                        placeholder="请输入开户银行"
                                />
                                </li>
                                <li class="flexbetween">
              <span class="flex">银行账号</span
              ><input
                                        id="bankID"
                                        v-model="submit.bankid"
                                        placeholder="请输入银行账号"
                                />
                                </li>
                            </div>
                        </ul>
                    </div>
                </div>
                <!-- 底部汇总 -->
                <footer>
                    <div class="ButtonWrap clearfix">
                        <div class="flex Yes" @click="SubmitData(3,'')"><span>提交</span></div>
                        <!--      <div class="flex No"><span>取消</span></div>-->
                    </div>
                </footer>
            </div>
        </div>
        <!-- 发票维护列表 -->
        <div class="ListWrapBox" v-if="boxstate">
            <div class="LineCut flexbetween">
                <div class="NewsTitle flexa"><p>发票维护</p></div>
                <div class="Return flexa" @click="CloseBox"><p>返回</p><img src="../../assets/Home/return.png"></div>
            </div>
            <div class="ContentListWrap">
                <ul>
                    <li v-for="(item,index) in invoicelisteditdata" :key="index">
                        <div class="Name">
                            <p style="margin-bottom: 0.18rem">{{ item.发票类型名称 }}</p>
                            <p>{{ item.发票抬头 }}</p>
                        </div>
                        <div class="Time">
                            <div class="Top clearfix">
                                <p>税号 <span>{{ item.税号 }}</span></p>
                            </div>
                        </div>
                        <div class="ButtonWrap flexa" style="height: 0.15rem">
                            <div class="Type" style="position: absolute;right: 0.1rem">
                                <div @click="OpenChangeInvoice(item.序号)" class="flex" style="background-color: #dba441"><p>编辑</p></div>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <div class="LineCut flexbetween">
            <div class="NewsTitle flexa"><p>MY<span> INVOICE</span></p></div>
            <div class="Return flexa" @click="Return"><p>返回</p><img src="../../assets/Home/return.png"></div>
        </div>
        <div class="Item flexbetween">
            <div class="List flexa">
                <span
                   :class="{ Active: index == flag }"
                   v-for="(item, index) in itemdata"
                   :key="index"
                   @click="Tab(item.type, index)">{{ item.name }}
                </span>
            </div>
            <div class="List flexa"><div class="flex" @click="OpenAddBox"><span>新增</span></div><div class="flex" @click="OpenBox"><span>维护</span></div></div>
        </div>
        <div class="ContentListWrap">
            <ul>
                <!-- 未开票样式 -->
                <li v-for="(item,index) in invoicelistdata" :key="index" @click="OpenSubmitInvoiceBox(item)">
                    <div class="Name">
                        <p v-if="item.申请状态 === '已申请'">{{ item.显示状态 }}</p>
                        <p v-else style="opacity: 0">123</p>
                        <p>{{ item.产品名称 }}</p>
                    </div>
                    <div class="Time">
                        <div class="Top clearfix">
                            <p>订单号 <span>{{ item.订单编号 }}</span></p>
                        </div>
                    </div>
                    <div class="ButtonWrap flexbetween">
                        <div class="Type flexa">
                            <div class="flex color1" v-if="item.申请状态==='已申请'"><p>{{ item.申请状态 }}</p></div>
                            <div class="flex color4" v-else><p>{{ item.申请状态 }}</p></div>
                        </div>
                        <div class="Next flexj">
                            <div class="flex"><p>开票金额 ￥<span>{{ item.开票金额 }}</span></p></div>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
  import { mapGetters } from 'vuex';
  export default {
    inject: [
      'load'
    ],
    data() {
      return {
        flag: 0,
        typeflag: '',
        EditInvoiceState: false,
        AddInvoiceState: false,
        choosestate: false,
        chooseflag: -1,
        state: true,
        SubmitInvoiceState: false,
        invoicedetaildata: {},
        submitinvoice: {},
        boxstate: false,
        invoicelistdata: [],
        typestate: true,
        typestates: true,
        types: true,
        user: '',
        phone: '',
        address: '',
        head: '',
        flagid: '',
        invoicelisteditdata: [],
        invoicechoosedata: [],
        choosedinvoice: {},
        chooseflaga: '',
        submit: {
          head: '',
          id: '',
          address: '',
          phone: '',
          bank: '',
          bankid: ''
        },
        itemdata: [
          {
            name: '全部',
            type: ''
          },
          {
            name: '未申请',
            type: '未申请'
          },
          {
            name: '已申请',
            type: '已申请'
          }
        ]
      };
    },
    computed: {
      ...mapGetters(['LoginUserInfo', 'UserInfo'])
    },
    created() {
      this.typeflag = '';
      /*  this.GetInvoiceList(''); */
      this.GetInvoiceListData('');
    },
    methods: {
      /* 申请开票 */
      SubmitInvoice(user, phone, address, types, head) {
        this.load.show();
        this.$axios({
          method: 'POST',
          url: 'https://x6.goeasy.cn/cli/client/Web_OnClickButtonOfBill',
          data: {
            commandId: 'WBA0007026',
            buttonText: 'Verify',
            userId: 'GoeasyUser' + this.LoginUserInfo.userId,
            headData: {
              /* 用户ID,申请编号,开票方式,发票类型,发票抬头,联系人,联系地址,联系电话,序号 */
              申请编号: this.invoicedetaildata.申请编号,
              发票类型: types === 'MN016690000000000000000002' ? this.type : '',
              开票方式: types,
              发票抬头: head || this.submitinvoice.发票抬头,
              联系人: user,
              联系地址: address,
              联系电话: phone,
              订单编号: this.invoicedetaildata.订单编号,
              序号: this.submitinvoice.序号 - 0,
              用户ID: this.LoginUserInfo.goeasyid
            },
            saveGridData: 1
            /*   gridData: this.chooseitems */
          }
        })
          .then(res => {
            this.load.hide();
            if (res.data.code === 0) {
              console.log(res);
              this.$message.success('申请开票成功！');
              this.GetInvoiceListData(this.typeflag);
              this.user = '';
              this.phone = '';
              this.address = '';
              this.CloseSubmitInvoice();
            } else {
              this.$message.error(res.data.msg);
            }
          })
          .catch(error => {
            this.load.hide();
            this.$message.error(error);
            console.log(error);
          });
      },
      SubmitInvoicedata() {
        if (this.types) {
          if (
            this.user &&
            this.phone &&
            this.address &&
            this.submitinvoice.发票抬头
          ) {
            this.SubmitInvoice(this.user, this.phone, this.address, this.types
                                 ? 'MN016690000000000000000002'
                                 : 'MN016690000000000000000001',
                               this.head);
          } else {
            this.$message.error('还有未填项！请确认！');
          }
        } else {
          if (this.user && this.phone && this.address && this.head) {
            this.SubmitInvoice(this.user, this.phone, this.address, this.types
                                 ? 'MN016690000000000000000002'
                                 : 'MN016690000000000000000001',
                               this.head);
          } else {
            this.$message.error('还有未填项！请确认！');
          }
        }
      },
      /* 选择发票 */
      ChooseThis(data, index, e) {
        e.stopPropagation();
        this.chooseflag = index;
        this.choosedinvoice = data;
      },
      /* 确认选择 */
      SubmitThis(e) {
        e.stopPropagation();
        this.choosestate = false;
        this.submitinvoice = this.choosedinvoice;
        this.chooseflaga = this.chooseflag;
        console.log(this.submitinvoice);
      },
      CloseChooseList() {
        if (!this.submitinvoice.发票抬头) {
          this.chooseflag = -1;
        } else {
          this.chooseflag = this.chooseflaga;
          this.choosedinvoice = this.submitinvoice;
        }
        this.choosestate = false;
      },
      OpenInvoiveList() {
        this.GetInvoiceList(this.state
          ? 'MN037590000000000000000001'
          : 'MN037590000000000000000002');
      },
      ChangeType(e) {
        if (this.SubmitInvoiceState) {
          this.state = e;
        } else if (this.AddInvoiceState) {
          this.typestates = e;
        } else if (this.EditInvoiceState) {
          this.typestate = e;
        }
        this.chooseflag = -1;
        this.chooseflaga = -1;
        this.choosedinvoice = {};
        this.submitinvoice = {};
        this.type = e
          ? 'MN037590000000000000000001'
          : 'MN037590000000000000000002';
      },
      ChangeFrom(e) {
        this.types = e;
      },
      CloseSubmitInvoice() {
        this.chooseflag = -1;
        this.chooseflaga = -1;
        this.choosedinvoice = {};
        this.submitinvoice = {};
        this.SubmitInvoiceState = false;
      },
      OpenSubmitInvoiceBox(type) {
        this.load.show();
        this.$axios({
          method: 'POST',
          url: 'https://x6.goeasy.cn/cli/client/Web_GetCommandDatas',
          data: {
            commandId: 'WBA0007024',
            userId: 'GoeasyUser' + this.LoginUserInfo.userId,
            filter: { 订单编号: type.订单编号 }
          }
        })
          .then(res => {
            this.load.hide();
            if (res.data.code === 0) {
              console.log(res);
              if (type.申请状态 === '未申请') {
                this.invoicedetaildata = res.data.data.DETAIL[0];
                this.SubmitInvoiceState = true;
              } else {
                this.invoicehasboxstate = true;
                this.invoicehasdetaildata = res.data.data.DETAIL[0];
              }
            } else {
              this.$message.error(res.data.msg);
            }
          })
          .catch(error => {
            this.load.hide();
            this.$message.error(error);
            console.log(error);
          });
      },
      /* 获取发票详情 */
      GetInvoiceDetail(id) {
        this.$axios({
          method: 'POST',
          url: 'https://x6.goeasy.cn/cli/client/Web_GetCommandDatas',
          data: {
            commandId: 'WBA0007029',
            userId: 'GoeasyUser' + this.LoginUserInfo.userId,
            filter: { 序号: id }
          }
        })
          .then(res => {
            if (res.data.code === 0) {
              console.log(res);
              this.load.hide();
              let data = {
                head: res.data.data.DETAIL[0].发票抬头,
                id: res.data.data.DETAIL[0].税号,
                address: res.data.data.DETAIL[0].注册地址,
                phone: res.data.data.DETAIL[0].注册电话,
                bank: res.data.data.DETAIL[0].开户银行,
                bankid: res.data.data.DETAIL[0].银行账号
              };
              if (res.data.data.DETAIL[0].发票类型 === 'MN037590000000000000000002') {
                this.typestate = true;
              } else {
                this.typestate = false;
              }
              this.submit = data;
              this.EditInvoiceState = true;
            } else {
              this.$message.error(res.data.msg);
            }
          })
          .catch(error => {
            this.load.hide();
            this.$message.error(error);
            console.log(error);
          });
      },
      OpenChangeInvoice(id, e) {
        this.flagid = id;
        if (e) {
          e.stopPropagation();
        }
        this.GetInvoiceDetail(id);
      },
      CloseChangeInvoice() {
        this.submit = {};
        this.EditInvoiceState = false;
      },
      /* 提交发票 */
      SubmitAdd(data, type, deleteflag, id) {
        console.log(data, type, deleteflag, id);
        this.load.show();
        this.$axios({
          method: 'POST',
          url: 'https://x6.goeasy.cn/cli/client/Web_OnClickButtonOfBill',
          data: {
            commandId: 'WBA0007028',
            buttonText: 'Verify',
            userId: 'GoeasyUser' + this.LoginUserInfo.userId,
            headData: {
              发票类型: type,
              发票抬头: data.head,
              税号: data.id,
              注册地址: data.address,
              注册电话: data.phone,
              开户银行: data.bank,
              银行账号: data.bankid,
              有效标记: deleteflag,
              序号: id || ''
            },
            saveGridData: 1
            /*   gridData: this.chooseitems */
          }
        })
          .then(res => {
            this.load.hide();
            if (res.data.code === 0) {
              console.log(res);
              if (deleteflag === 0) {
                this.$message.success('删除成功！');
                this.GetInvoiceList('');
                this.ClearData();
                this.EditInvoiceState = false;
              } else if (deleteflag === 3 && id) {
                this.GetInvoiceList('');
                this.$message.success('修改成功！');
                this.EditInvoiceState = false;
                this.ClearData();
              } else {
                this.$message.success('新增发票成功！可在维护界面进行维护操作');
                this.CloseAddInvoice();
              }
              this.typestate = true;
            } else {
              this.$message.error(res.data.msg);
            }
          })
          .catch(error => {
            this.load.hide();
            this.$message.error(error);
            console.log(error);
          });
      },
      OpenAddBox() {
        this.AddInvoiceState = true;
      },
      SubmitData(flag1, id) {
        let flag = true;
        let fl = '';
        if (flag1 === 3 && id) {
          fl = this.typestate;
        } else if (flag1 === 3 && !id) {
          fl = this.typestates;
        }
        if (fl && flag1 !== 0) {
          for (let i in this.submit) {
            if (!this.submit[i]) {
              this.$message.error('还有未填项');
              flag = false;
              return;
            } else {
              flag = true;
            }
          }
        } else if (!fl && flag1 !== 0) {
          if (this.submit.head && this.submit.id) {
            flag = true;
          } else {
            this.$message.error('还有未填项');
            flag = false;
          }
        }
        if (flag) {
          console.log(this.submit);
          if (flag1 === 0) {
            this.$confirm('确认删除?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            })
              .then(() => {
                this.SubmitAdd(this.submit, fl
                                 ? 'MN037590000000000000000002'
                                 : 'MN037590000000000000000001',
                               flag1,
                               id);
              })
              .catch(() => {
                console.log('取消');
              });
          } else {
            this.SubmitAdd(this.submit, fl
                             ? 'MN037590000000000000000002'
                             : 'MN037590000000000000000001',
                           flag1,
                           id);
          }
        }
      },
      ClearData() {
        this.submit.head = '';
        this.submit.id = '';
        this.submit.address = '';
        this.submit.phone = '';
        this.submit.bank = '';
        this.submit.bankid = '';
      },
      CloseAddInvoice() {
        this.AddInvoiceState = false;
        this.ClearData();
      },
      /* 获取发票维护列表 */
      GetInvoiceList(type) {
        this.load.show();
        this.$axios({
          method: 'POST',
          url: 'https://x6.goeasy.cn/cli/client/Web_GetCommandDatas',
          data: {
            commandId: 'WBA0007027',
            userId: 'GoeasyUser' + this.LoginUserInfo.userId,
            filter: { 发票类型: type }
          }
        })
          .then(res => {
            this.load.hide();
            if (res.data.code === 0) {
              console.log(res);
              /* 如果通过开票页面获取的 */
              if (type) {
                this.invoicechoosedata = res.data.data.DETAIL;
                this.choosestate = true;
              } else {
                this.invoicelisteditdata = res.data.data.DETAIL;
                this.boxstate = true;
              }
            } else {
              this.$message.error(res.data.msg);
            }
          })
          .catch(error => {
            this.load.hide();
            this.$message.error(error);
            console.log(error);
          });
      },
      OpenBox() {
        this.GetInvoiceList('');
      },
      CloseBox() {
        this.boxstate = false;
      },
      /* 切换发票 */
      Tab(type, index) {
        console.log(type, index);
        this.flag = index;
        this.typeflag = type;
        this.GetInvoiceListData(type);
      },
      /* 获取发票列表 */
      GetInvoiceListData(type) {
        this.load.show();
        this.$axios({
          method: 'POST',
          url: 'https://x6.goeasy.cn/cli/client/Web_GetCommandDatas',
          data: {
            commandId: 'WBA0007023',
            userId: 'GoeasyUser' + this.LoginUserInfo.userId,
            filter: { 申请状态: type }
          }
        })
          .then(res => {
            this.load.hide();
            if (res.data.code === 0) {
              console.log(res);
              this.invoicelistdata = res.data.data.DETAIL;
            } else {
              this.$message.error(res.data.msg);
            }
          })
          .catch(error => {
            this.load.hide();
            this.$message.error(error);
            console.log(error);
          });
      },
      Return() {
        this.$router.back();
      }
    }
  };
</script>
<style lang="scss" scoped>
    @import '../../../public/Value';
    .Invoice{
        width: 100%;
        .InvoiceChooseList {
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, 0.6);
            position: absolute;
            z-index: 5;
            left: 0;
            top: 0;
            .ListContent {
                width: 26%;
                height: calc(100% - 1.7rem);
                background-color: #fff;
                border-radius: 0.05rem;
                .ChooseButton {
                    width: 100%;
                    height: 0.2rem;
                    div {
                        width: 0.8rem;
                        height: 0.2rem;
                        font-size: 0.051rem;
                        color: #fff;
                        border-radius: 0.1rem;
                        margin: 0 0.1rem;
                        cursor: pointer;
                    }
                    div:first-child {
                        background-color: #919191;
                    }
                    div:last-child {
                        background-color: #cc3333;
                    }
                }
                ul {
                    width: 100%;
                    height: calc(100% - 0.3rem);
                    overflow-y: scroll;
                    &::-webkit-scrollbar {
                        display: none;
                    }
                    li {
                        padding: 0.08rem 0;
                        width: 1.8rem;
                        margin: 0.05rem auto 0;
                        background-color: #7c7c7c;
                        border-radius: 0.05rem;
                        overflow: auto;
                        cursor: pointer;
                        i {
                            width: 0.15rem;
                            height: 0.15rem;
                            background-color: #979797;
                            font-size: 0.06rem;
                            color: #fff;
                            border-radius: 0.1rem;
                            margin: 0 0.05rem;
                            font-style: normal;
                        }
                        .TextWrap {
                            width: 1.3rem;
                            p {
                                font-size: $TextSize;
                                color: #fff;
                            }
                            p:first-child {
                                margin-bottom: 0.05rem;
                            }
                        }
                    }
                    li.Active {
                        background-color: #f1aa48;
                        i {
                            background-color: #ffc77a;
                        }
                    }
                }
            }
        }
        .AddInvoice{
            width: 100%;
            height: 100%;
            background-color: rgba(0,0,0,0.6);
            position: absolute;
            left: 0;
            top: 0;
            z-index: 4;
            .AddWrap{
                width: 30%;
                height: calc(100% - 1rem);
                background-color: #fff;
                border-radius: 0.1rem;
                .AddInvoiceType {
                    width: 2rem;
                    margin: 0.05rem auto 0;
                    .Active {
                        background-color: #bb4b47;
                    }
                    div {
                        width: 0.2rem;
                        height:0.2rem;
                        background-color: #888888;
                        border-radius: 0.05rem;
                        float: right;
                        margin-left: 0.04rem;
                        cursor: pointer;
                        span {
                            font-size: $SmallTitleSize;
                            color: #fff;
                        }
                    }
                }
                header {
                    width: 88%;
                    height: 0.2rem;
                    margin: 0 auto;
                    padding-top: 0.1rem;
                    position: relative;
                    i {
                        width: 0.1rem;
                        cursor: pointer;
                        img {
                            width: 100%;
                        }
                    }
                    p {
                        font-size: $SmallTitleSize;
                        color: #666666;
                        position: absolute;
                        right: 0;
                        font-weight: bold;
                    }
                }
                .AddInvoiceContent {
                    width: 100%;
                    margin: 0 auto;
                    height: calc(100% - 0.8rem);
                    overflow: scroll;
                    overflow-scrolling: touch;
                    .Type {
                        width: 86%;
                        margin: 0.1rem auto 0.05rem;
                        .Person,
                        .Camponey {
                            margin-right: 0.1rem;
                            font-size: $TextSize;
                            color: #414141;
                            opacity: 0.6;
                            cursor: pointer;
                        }
                        .Active {
                            opacity: 1;
                            font-size: $TextSize;
                            font-weight: bold;
                            color: #bb4b47;
                        }
                    }
                    .Productpic {
                        width: 86%;
                        margin: 0.1rem auto 0;
                        i {
                            width: 0.3rem;
                            height: 0.3rem;
                            border-radius: 0.02rem;
                            img {
                                width: 100%;
                                height: 100%;
                                object-fit: cover;
                                border-radius: 0.02rem;
                            }
                        }
                        p {
                            font-size: $SmallTitleSize;
                            color: #414141;
                            margin-top: 0.05rem;
                        }
                    }
                    .NumberWrap {
                        width: 86%;
                        margin: 0.08rem auto 0;
                        p {
                            font-size: $AdditionTextSize;
                            color: #414141;
                        }
                        p:last-child {
                            font-size: $SmallTextSize
                        }
                    }
                    .Choose {
                        width: 86%;
                        margin: 0 auto;
                        .InvoiceInfo {
                            width: 1.65rem;
                            height: 0.5rem;
                            background-color: #999999;
                            border-radius: 0.05rem;
                            cursor: pointer;
                            img {
                                width: 0.2rem;
                                margin-left: 0.1rem;
                            }
                            span {
                                font-size: $TextSize;
                                color: #fff;
                                margin-left: 0.2rem;
                            }
                        }
                        .ChooseType {
                            width: 0.3rem;
                            div {
                                width: 0.23rem;
                                height: 0.23rem;
                                background-color: #999999;
                                margin-bottom: 0.04rem;
                                border-radius: 0.05rem;
                                font-size: $SmallTitleSize;
                                color: #fff;
                                cursor: pointer;
                            }
                            .Active {
                                background-color: #bb4b47;
                            }
                            div:last-child {
                                margin-bottom: 0;
                            }
                        }
                    }
                    .InputWrap {
                        width: 86%;
                        margin: 0.1rem auto 0;
                        ul {
                            width: 100%;
                            li {
                                width: 100%;
                                margin-bottom: 0.1rem;
                                span {
                                    font-size: $TextSize;
                                    color: #414141;
                                }
                                input {
                                    width: 1.5rem;
                                    height: 0.18rem;
                                    color: #414141;
                                    background-color: #f5f5f5;
                                    font-size: $TextSize;
                                    text-indent: 0.08rem;
                                    border-radius: 0.05rem;
                                }
                                input::placeholder{
                                    font-size: $TextSize;
                                }
                            }
                            .tip {
                                margin-bottom: 0.08rem;
                                span {
                                    font-size: $SmallTextSize;
                                    color: rgba(65, 65, 65, 0.8);
                                }
                            }
                        }
                    }
                    &::-webkit-scrollbar {
                        display: none;
                    }
                }
                footer {
                    width: 100%;
                    height: 0.2rem;
                    .ButtonWrap {
                        width: 90%;
                        margin: 0 auto;
                        height: 0.2rem;
                        position: relative;
                        div:last-child {
                            margin-left: 0 !important;
                        }
                        .Yes,
                        .No {
                            width: 0.4rem;
                            height: 0.15rem;
                            float: right;
                            margin-left: 0.1rem;
                            background-color: #26a2ff;
                            border-radius: 0.8rem;
                            cursor: pointer;
                            span {
                                font-size: $TextSize;
                                color: #fff;
                            }
                        }
                        .Yes {
                            background-color: #8c73b5;
                        }
                        .No {
                            background-color: #666666;
                        }
                    }
                }
            }
        }
        .EditIncoive{
            z-index: 6 !important;
        }
        .ListWrapBox{
            width: 50%;
            height:calc(100% - 0.8rem);
            top:0.8rem;
            left: 25%;
            position: fixed;
            z-index: 2;
            background-color: #000;
            overflow-y: scroll;
            &::-webkit-scrollbar{
                display: none;
            }
        }
        .LineCut{
            width: 90%;
            margin: 0.05rem auto 0.05rem;
            border-bottom: 2px solid #fff;
            .Return{
                cursor: pointer;
                p{
                    font-size: $AdditionTextSize;
                    color: #fff;
                }
                img{
                    width: 0.05rem;
                    margin-left: 0.02rem;
                }
            }
            .NewsTitle{
                p{
                    font-size: $TitleSize;
                    color: #fff;
                    padding-bottom: 0.045rem;
                    span{
                        opacity: 0.6;
                        font-weight: normal;
                    }
                }
            }
        }
        .Item{
            width: 90%;
            margin: 0.05rem auto 0.1rem;
            .List{
                span{
                    font-size: $AdditionTextSize;
                    color: #fff;
                    opacity: 0.7;
                    margin-right: 0.1rem;
                    cursor: pointer;
                }
                span.Active{
                    opacity: 1;
                    font-weight: bold;
                }
            }
            .List:last-child{
                div:first-child{
                    background-color: #dba441;
                }
                div:last-child{
                    background-color: #993333;
                }
                div{
                    margin-left: 0.1rem;
                    margin-right: 0;
                    width: 0.3rem;
                    height: 0.1rem;
                    border-radius: 0.12rem;
                    span{
                        color: #fff;
                        opacity: 1;
                        margin-right: 0;
                    }
                }
            }
        }
        .ContentListWrap{
            width: 90%;
            margin: 0.1rem auto;
            ul{
                width: 100%;
                li{
                    width: 100%;
                    border: 1px solid #fff;
                    border-radius: 0.08rem;
                    margin-bottom: 0.1rem;
                    position: relative;
                    cursor: pointer;
                    padding: 0.06rem 0;
                    .color1{
                        background-color: #339933;
                    }
                    .color3{
                        background-color: #666666;
                    }
                    .color4{
                        background-color: #993333;
                    }
                    .ButtonWrap{
                        width: calc(100% - 0.2rem);
                        margin-left: 0.1rem;
                        margin-top: 0.05rem;
                        .Next{
                            div{
                                p{
                                    font-size: $TextSize;
                                    color: #fff;
                                    span{
                                        font-size: $TitleSize;
                                        font-weight: bold;
                                    }
                                }
                            }
                        }
                        .Type{
                            div{
                                width: 0.4rem;
                                height: 0.15rem;
                                border-radius: 0.2rem;
                                cursor: pointer;
                                p{
                                    font-size: $TextSize;
                                    color: #fff;
                                }
                            }
                        }
                    }
                    .Time{
                        position: absolute;
                        right: 0.12rem;
                        top: 0.1rem;
                        .Top{
                            margin-bottom: 0.05rem;
                            p{
                                font-size: $AdditionTextSize;
                                color: #fff;
                                opacity: 0.7;
                                margin-left: 0.1rem;
                                float: right;
                            }
                        }
                    }
                    .Name{
                        padding: 0.1rem 0 0 0.1rem;
                        p:first-child{
                            font-size: $AdditionTextSize;
                            color: #fff;
                            opacity: 0.7;
                            margin-bottom: 0.05rem;
                        }
                        p:last-child{
                            font-size: $TitleSize;
                            color: #fff;
                        }
                    }
                }
            }
        }
    }
</style>
